<template>
    <b-overlay :show="show">
        <div class="p-4">
            <div class="d-flex mb-3">
                <div class="mx-2 d-flex align-items-center">
                    <i-name width="2.5em" height="2.5em"></i-name>
                </div>

                <div class="d-flex flex-column align-items-start">
                    <p class="text-muted mb-0">{{t('Full name')}}</p>
                    <h5>{{personal_info.first_name}} {{personal_info.father_name}}
                        {{personal_info.last_name}}</h5>
                </div>
            </div>

            <div class="d-flex mb-3">
                <div class="mx-2 d-flex align-items-center">
                    <i-serial width="2.5em" height="2.5em"></i-serial>
                </div>

                <div class="d-flex flex-column align-items-start">
                    <p class="text-muted mb-0">{{t('Serial')}}</p>
                    <h5>{{personal_info.serial_number}}</h5>
                </div>
            </div>

            <div class="d-flex">
                <div class="mx-2 d-flex align-items-center">
                    <i-lock-masked width="2.5em" height="2.5em"></i-lock-masked>
                </div>

                <div class="d-flex flex-column align-items-start">
                    <p class="text-muted mb-0">{{t('Password')}}</p>
                    <h5>{{personal_info.serial_number.substr(personal_info.serial_number.length - 4)}}</h5>
                </div>
            </div>

            <div class="d-flex justify-content-center">
                <b-img block @load="show = false" class="w-75" style="height: intrinsic;"
                       :src="'https://chart.googleapis.com/chart?cht=qr&chs=128x128&chl=' + personal_info.serial_number"></b-img>
            </div>

            <div class="d-flex justify-content-center">
                <b-button class="px-5" :to="{name: 'edit profile'}" variant="primary" pill>{{t('Edit')}}</b-button>
            </div>
        </div>
    </b-overlay>
</template>

<script>
    import IName from "../../components/Icons/IName";
    import ILockMasked from "../../components/Icons/ILockMasked";
    import ISerial from "../../components/Icons/ISerial";

    export default {
        name: "Me",
        inject: ['patientRepo'],
        components: {
            ILockMasked,
            IName,
            ISerial
        },
        data: () => ({
            personal_info: {
                serial_number: ''
            },
            show: true,
        }),
        mounted() {
            this.patientRepo.getUser().then(({patient}) => {
                this.personal_info = patient;
            })
        }
    }
</script>

<style lang="scss" scoped>

</style>
